import { enableFade } from 'core/handlers/FadeHandler'
import { signal } from 'services/SignalsService'

export default class AutomenuEntity extends PIXI.Container {
  constructor() {
    super()
    const fade = enableFade(this)

    signal.on('RADIO:ui', (value) => {
      fade(value == 'automenu')
      const isAutomenu = value == 'automenu' ? 'automenu' : ''
      if (value === 'automenu'){
        signal.dispatch(`RADIO:menu:${isAutomenu}`)
      }
    })
  }
}
